import { DOC_CONVERSION_FAILURE } from '../constants/newRelic';
import { reorderUnavailableFailureReasons } from '../constants/reorder';
import { ITEM_ADD_FAILURE_REASON } from '../constants/tracking';
import type { ReorderResponse } from '../types/reorder.types';
import type { ReorderItemError } from '../types/ReorderableItems.types';

export const isDocumentConversionFailure = (reorderResponse: ReorderResponse) =>
  reorderResponse?.results?.some(
    (result) =>
      result.successful === false &&
      result.failureReason === DOC_CONVERSION_FAILURE
  ) || false;

export const isProductUnavailableForReorder = (
  reorderResponse: ReorderResponse
) =>
  reorderResponse?.results?.some(
    (result) =>
      result.successful === false &&
      reorderUnavailableFailureReasons.includes(result.failureReason)
  ) || false;

/**
 * Type guard to check if error is a ReorderItemError
 */
const isReorderItemError = (e: unknown): e is ReorderItemError => {
  return (
    typeof e === 'object' &&
    e !== null &&
    'results' in e &&
    Array.isArray((e as ReorderItemError).results)
  );
};

/**
 * Gets the flawed ux failure reasons for a reorder item action.
 */
export const getReorderItemFailureReasons = (e: unknown): string[] => {
  const reasons: string[] = [];

  if (!isReorderItemError(e)) {
    reasons.push(ITEM_ADD_FAILURE_REASON.GENERIC);
    return reasons;
  }

  if (isDocumentConversionFailure(e)) {
    reasons.push(ITEM_ADD_FAILURE_REASON.DOC_CONVERSION);
  }
  if (isProductUnavailableForReorder(e)) {
    reasons.push(ITEM_ADD_FAILURE_REASON.PRODUCT_UNAVAILABLE);
  }
  if (!reasons.length) {
    reasons.push(ITEM_ADD_FAILURE_REASON.GENERIC);
  }
  return reasons;
};
